import React from "react";

import { isNull } from "../../../components/common/Common";

function SalesSearchEmptyResult({}) {
  return (
    <>
      <div className="main-box" style={{ marginTop: "30px" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div>매출현황이 없습니다.</div>
        </div>
      </div>
    </>
  );
}

export default SalesSearchEmptyResult;
